import axios from 'axios';

import client from '@/lib/feathers';
import type Message from '@/types/database/message';

const messageService = client.service('message');

export const getDataSource = (
  databaseData: Message[],
  showDataType: 'baEvent' | 'system' | 'personal'
) => {
  if (showDataType === 'personal') {
    const dataSource = databaseData.filter((data) => {
      return data.class === 'message' && data.title === '個人通知';
    });
    return dataSource;
  }
  if (showDataType === 'system') {
    const dataSource = databaseData.filter((data) => {
      return (
        (data.class !== 'baEvent' && data.class !== 'message') ||
        data.title === '[管理員通知]系統事件'
      );
    });
    return dataSource;
  }

  const dataSource = databaseData.filter((data) => {
    return data.class === 'baEvent';
  });
  return dataSource;
};

export const markAsRead = async (id: string) => {
  try {
    await messageService.patch(id, { readed: true });
  } catch (error) {
    console.error(`通知id:[${id}]修改成已讀失敗:`, error);
  }
};

export const updateNoticesReadStatus = async () => {
  try {
    await axios('/ezcon/api/users/me/messages/readAll', {
      method: 'POST',
      headers: {
        authorization: window.localStorage['feathers-jwt'],
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const getNotifications = (
  messages: Message[],
  currentTab: 0 | 1 | 2
) => {
  if (currentTab === 1) {
    const notifications = getDataSource(messages, 'system');
    return notifications;
  }
  if (currentTab === 2) {
    const notifications = getDataSource(messages, 'baEvent');
    return notifications;
  }

  const notifications = getDataSource(messages, 'personal');
  return notifications;
};

export const getNoticeType = (currentTab: 0 | 1 | 2) => {
  if (currentTab === 0) {
    return 'personal';
  }
  if (currentTab === 1) {
    return 'system';
  }
  return 'baEvent';
};
